"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var SalesDashboardComparatorRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SalesDashboardComparatorRowDTOConverter, _DataObjectConverter_);

  function SalesDashboardComparatorRowDTOConverter() {
    _classCallCheck(this, SalesDashboardComparatorRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardComparatorRowDTOConverter).apply(this, arguments));
  }

  return SalesDashboardComparatorRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SalesDashboardComparatorRowDTOConverter = SalesDashboardComparatorRowDTOConverter;